import React from "react";
import { ListItem, ListItemText, Grid, Typography } from "@material-ui/core";
import { complaintTypesService, stagesService } from "../../services";
import { useFieldLookup } from "../../hooks/useFieldLookup";
import { CaseRowSLAs } from "./CaseRowSLAs";
import { CaseRowIcon } from "./CaseRowIcon";
import { utcToLocalDate, utcToLocalDateTime } from "../../utils/dateUtils";
const CaseRow = ({ element: item, onNavigate }) => {
    const caseType = useFieldLookup(complaintTypesService, item.caseType);
    const stage = useFieldLookup(stagesService, item.stage);
    return (React.createElement("div", { className: "CaseRow" },
        React.createElement(ListItem, { className: "GestureArea", button: true, onClick: () => onNavigate(item.id), "data-test": "case-row" },
            React.createElement(Grid, { container: true, spacing: 0, direction: "row", alignItems: "center" },
                React.createElement(Grid, { item: true, md: 6, lg: 9, style: { paddingLeft: "60px" } },
                    React.createElement(CaseRowIcon, { item: item }),
                    React.createElement(ListItemText, { primary: React.createElement(React.Fragment, null,
                            React.createElement(Typography, { component: "span", className: "inlineTitle", color: "textSecondary", "data-test": "case-ofqual-id" }, item.ofqualId),
                            "\u00A0\u00A0",
                            React.createElement("span", { "data-test": "case-title" }, item.title),
                            "\u00A0\u00A0(",
                            React.createElement("span", { "data-test": "case-type" }, caseType),
                            ")") }),
                    React.createElement("p", null,
                        React.createElement("span", { className: "caseRowDetails" },
                            React.createElement("strong", null, "Received:"),
                            " ",
                            utcToLocalDateTime(item.receiptDate),
                            " (",
                            item.source,
                            ")"),
                        React.createElement("span", { className: "caseRowDetails" },
                            React.createElement("strong", null, "Created:"),
                            " ",
                            utcToLocalDateTime(item.createdDate)),
                        React.createElement("span", { className: "caseRowDetails" },
                            React.createElement("strong", null, "Status:"),
                            " ",
                            item.status),
                        item.closedDate ? (React.createElement("span", { className: "caseRowDetails" },
                            React.createElement("strong", null, "Closed:"),
                            " ",
                            utcToLocalDate(item.closedDate))) : null,
                        React.createElement("span", { className: "caseRowDetails" },
                            React.createElement("strong", null, "Stage:"),
                            " ",
                            stage))),
                React.createElement(Grid, { item: true, md: 6, lg: 3 }, item.status === "Active" && (React.createElement(CaseRowSLAs, { caseDates: item.caseDates, caseId: item.id, isPaused: item.slaPaused })))))));
};
export default CaseRow;
